import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-infos-add-colab',
  templateUrl: './infos-add-colab.component.html',
  styleUrls: ['./infos-add-colab.component.scss']
})
export class InfosAddColabReadComponent {
  admissionDate: string;

  @Input() infos: any;
  @Output() clipboard: EventEmitter<Object> = new EventEmitter<Object>();
}
